module.exports = __webpack_public_path__ + "static/img/joinUs3.975a6c75.png";